import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';

export const team = () => {
  const container = document.querySelector('.wp-block-team');
  if (!container) return;

  //set resetSelects to true to reset other selects when a new one is selected
  const { resetSelects } = container.dataset;

  const inner = container.querySelector('.wp-block-team__inner');

  const swup = new Swup({
    plugins: [new SwupScrollPlugin(), new SwupPreloadPlugin()],
    animationSelector: '.wp-block-team__inner',
    containers: ['.wp-block-team__inner'],
    linkSelector: '.wp-block-team .pagination a',
    ignoreVisit: (url) => {
      const path = url.split('?')[0];
      return path !== window.location.pathname;
    },
  });

  // TEAM LOAD MORE

  const itemsPerPage = 24;
  let currentBatch = 1;
  let teamItems = [...document.querySelectorAll('.team-item')]; // Convert NodeList to Array

  const showItems = (batch) => {
    const start = (batch - 1) * itemsPerPage;
    const end = batch * itemsPerPage;
    teamItems.slice(start, end).forEach((item) => {
      item.classList.add('visible');
    });
  };

  const resetItems = () => {
    teamItems.forEach((item) => item.classList.remove('visible')); // Remove visibility from all items
    currentBatch = 1; // Reset batch counter
    showItems(currentBatch); // Show the first batch (first 24 items)
  };

  // Load More Button Click Handler
  const attachLoadMoreEvent = () => {
    const loadMoreButton = document.getElementById('team-load-more');
    if (!loadMoreButton) return;

    loadMoreButton.addEventListener('click', (e) => {
      e.preventDefault();
      currentBatch++;
      showItems(currentBatch);

      if (currentBatch * itemsPerPage >= teamItems.length) {
        loadMoreButton.style.display = 'none'; // Hide button if no more items to load
      }
    });
  };

  // Initially show the first batch and attach load more event
  showItems(currentBatch);
  attachLoadMoreEvent(); // Attach event when page first loads

  // TEAM SEARCH

  const search = container.querySelector('input');

  const updateUrlAndNavigate = (term) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (term) {
      urlParams.set('term', term);
    } else {
      urlParams.delete('term');
    }

    const url = new URL(window.location);
    url.search = urlParams.toString();

          console.log(url.search);
      console.log(swup.navigate(url.toString(), { history: 'replace' }));

    swup.navigate(url.toString(), { history: 'replace' });
  };

  search.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      updateUrlAndNavigate(search.value);
      container.classList.add('search-active');
      search.classList.toggle('is-active', !!search.value);
    }
  });

  search.addEventListener('blur', () => {
    if (!search.value) {
      search.classList.remove('is-active');
      container.classList.remove('search-active');
      updateUrlAndNavigate('');

      // Reset items manually after search clear
      resetItems();
    }
  });

  // Swup hook for content replace, ensure items reset after transitions
  swup.hooks.on(
    'content:replace',
    () => {
      // Refresh the teamItems list as the DOM is replaced
      teamItems = [...document.querySelectorAll('.team-item')];
      resetItems(); // Reset and show the first 24 items

      // Re-attach load more event after DOM replacement
      attachLoadMoreEvent();
    },
    { before: false },
  );

  // TEAM FILTERS

  // prevent scroll to top
  swup.scrollTo = () => {};

  const selects = container.querySelectorAll('select');
  selects.forEach((select) => {
    const type = select.getAttribute('data-type');

    // set initial value from URL params, if select has the value
    const urlParams = new URLSearchParams(window.location.search);
    if (
      // url param is set
      urlParams.get(type) &&
      // select has an option with the value
      select.querySelector(`option[value="${urlParams.get(type)}"]`)
    ) {
      select.value = urlParams.get(type);
    }

    select.addEventListener('change', (e) => {
      if (resetSelects) {
        // reset other selects
        selects.forEach((s) => {
          if (s === select) return;
          s.classList.remove('is-active');
          s.value = '';
        });
      }

      // new url params
      const urlParams = new URLSearchParams(window.location.search);
      if (e.target.value) {
        urlParams.set(type, e.target.value);
      } else {
        urlParams.delete(type);
      }

      const url = new URL(window.location);
      url.search = urlParams.toString();

      console.log(url.search);

      swup.navigate(url.toString(), { history: 'replace' });

      select.classList.toggle('is-active', !!select.value);
    });
  });
};
